<template>
  <div class="container">
    <div class="jl-tips-shadow"></div>
    <h2>购物车</h2>
    <div class="jl-cart-list-wrapper">
      <div class="jl-cart-list-head">
        <div class="jl-cart-list-head-checkall">
          <span
            class="fa"
            :class="{ 'checked-active': initSelectedAll }"
            @click="selectAll"
          ></span>
        </div>
        <ul>
          <li @click="selectAll">全选</li>
          <li>商品</li>
          <li>单价</li>
          <li>数量</li>
          <li>金额</li>
          <li>操作</li>
        </ul>
      </div>
      <div class="jl-cart-list-content">
        <div v-loading="isloading" class="jl-loading-box">
          <div class="js-cart-tips" v-if="nodata && !isloading">
            <div class="js-cart-tips-box">
              <i class="jl-icon-cart2"></i>
              <p class="text-tips">暂无商品，快去选择商品吧</p>
              <p class="text-tips-btn" @click="gotoshop">逛一逛</p>
            </div>
          </div>
          <div
            class="jl-cart-list-item"
            v-for="(item, index) in cartData"
            :key="item.id"
          >
            <div class="jl-cart-list-item-check">
              <span
                class="fa"
                :class="{ 'checked-active': item.cartChecked }"
                @click="selectIndex(index)"
              ></span>
            </div>
            <ul>
              <li>
                <img :src="item.image" alt="pic" />
              </li>
              <li>
                <p class="cart-list-title" @click="goToShopDetail(item)">
                  {{ item.goods.name }}
                </p>
                <p class="text3" v-if="item.series">
                  系列：{{ item.series }} / 颗粒：{{ item.particles }} /
                  包装：{{ item.pack }}
                </p>
                <p class="text3" v-else-if="item.specification">
                  规格：{{ item.specification }}
                </p>
              </li>
              <li>￥{{ item.price }}</li>
              <li>
                <button
                  class="jl-icon-plus-minus"
                  @click="minusIndex(index)"
                ></button>
                <input
                  v-model="item.total"
                  type="text"
                  @change="checkVal(index)"
                />
                <button class="jl-icon-Plus" @click="plusIndex(index)"></button>
              </li>
              <li>￥{{ item.amount }}</li>
              <li @click="deleteIndex(item, index)">删除</li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="jl-cart-list-head jl-cart-list-foot"
        v-show="cartData.length > 0"
      >
        <div class="jl-cart-list-head-checkall">
          <span
            class="fa"
            :class="{ 'checked-active': initSelectedAll }"
            @click="selectAll"
          ></span>
        </div>
        <div class="jl-cart-list-foot-left">
          <span @click="selectAll">全选</span>
          <span @click="deleteAll">删除选中的商品</span>
        </div>
        <div class="jl-cart-list-foot-right">
          <div class="jl-cart-list-foot-right-totalnum">
            已选择
            <span>{{ totalSelected }}</span
            >项商品
          </div>
          <div class="jl-cart-list-foot-right-summary">
            <p>
              总计：
              <span>￥{{ totalAmount }}</span>
            </p>
            <p>(不含运费)</p>
          </div>
          <button @click="submit">去结算</button>
        </div>
      </div>
      <div class="jl-page-box clearfix" v-if="cartData.length > 0">
        <div style="float: right">
          <v-pagination
            :total="totalsize"
            :display="display"
            :currentPage="current"
            @pagechange="pagechange"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCartList, delCart } from '../../api/shop';
import Pagination from '../../components/Pagination';
export default {
  name: 'cartList',
  components: {
    'v-pagination': Pagination
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== 'shopDetailOrder') {
      next(vm => {
        //其他页面今天购物车，清除缓存重新渲染数据
        Object.assign(vm.$data, vm.$options.data());
        vm.initData();
      });
    } else {
      next(vm => {
        vm.createdBool && vm.initData();
      });
    }
  },
  data() {
    return {
      createdBool: true,
      initSelectedAll: false,
      initSelected: [],
      selectArr: [],
      initRelKey: 'id',
      cartData: [],
      totalAmount: 0,
      userId: 2,
      totalsize: 1,
      display: 10,
      current: 1,
      isloading: true,
      nodata: false
    };
  },
  computed: {
    totalSelected() {
      return this.initSelected.length;
    },
    ...mapGetters(['userInfo', 'cartItemData'])
  },
  created() {
    // this.initData();
  },
  methods: {
    gotoshop() {
      this.$router.push({
        name: 'shopIndex'
      });
    },
    pagechange(idx) {
      window.scrollTo(0, 0);
      this.current = idx;
      this.selectArr = [];
      this.initSelected = [];
      this.initData();
    },
    initData() {
      getCartList(this, () => {
        this.init();
      });
    },
    getCartLiatCurrent1() {
      getCartList(
        this,
        () => {
          this.init();
        },
        true
      );
    },
    init() {
      // 设置选中项
      this.totalAmount = 0;
      this.selectArr = [];
      this.cartData.forEach(e => {
        e.cartChecked = false;
        if (this.initSelected.indexOf(e[this.initRelKey]) >= 0) {
          e.cartChecked = true;
          this.selectArr.push(e);
          this.totalAmount += e.price * e.total;
        }
        e.amount = e.price * e.total;
      });

      if (
        this.cartData.length === this.initSelected.length &&
        this.cartData.length > 0
      ) {
        this.initSelectedAll = true;
      } else {
        this.initSelectedAll = false;
      }
    },
    checkVal(index) {
      // 检查输入框的值
      if (
        isNaN(this.cartData[index].total) ||
        this.cartData[index].total <= 0
      ) {
        this.cartData[index].total = 1;
      }
      if (this.cartData[index].total % 1 != 0) {
        this.cartData[index].total = parseFloat(this.cartData[index].total);
      }
    },
    selectAll() {
      // 全选
      this.initSelectedAll = !this.initSelectedAll;
      if (this.initSelectedAll) {
        this.cartData.forEach(e => {
          if (this.initSelected.indexOf(e[this.initRelKey]) < 0) {
            this.initSelected.push(e[this.initRelKey]);
          }
        });
      } else {
        this.initSelected = [];
      }
      //console.log(this.initSelected);
      this.init();
    },
    selectIndex(index) {
      // 单选
      let a = this.cartData[index];
      this.cartData[index].cartChecked = !this.cartData[index].cartChecked;
      if (this.cartData[index].cartChecked) {
        this.initSelected.push(a[this.initRelKey]);
      } else {
        this.initSelected.forEach((e, i) => {
          if (e == a[this.initRelKey]) {
            this.initSelected.splice(i, 1);
          }
        });
      }
      this.init();
    },
    deleteAll() {
      // 批量删除
      // TODO 调接口删除购物车表内容
      if (this.initSelected.length == 0) {
        this.$notify({
          title: '提示',
          message: '请选择要删除的数据',
          type: 'warning'
        });
        return;
      }
      this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (this.initSelected.length === 1) {
            delCart(this, this.initSelected[0], res => {
              if (res.code === 200) {
                this.afterAllDel();
                if (this.current > 1) {
                  if (this.cartData.length === 0) {
                    this.current--;
                  }
                  getCartList(this, () => {
                    this.init();
                  });
                }
                this.nodata = this.cartData.length > 0 ? false : true;
              } else {
                this.$notify({
                  title: '提示',
                  message: '删除失败：' + JSON.stringify(res),
                  type: 'error'
                });
              }
            });
          } else {
            delCart(this, this.initSelected, res => {
              if (res.code === 200) {
                this.afterAllDel();
                if (this.current > 1) {
                  if (this.cartData.length === 0) {
                    this.current--;
                  }
                  getCartList(this, () => {
                    this.init();
                  });
                }
                this.nodata = this.cartData.length > 0 ? false : true;
              } else {
                this.$notify({
                  title: '提示',
                  message: '删除失败：' + JSON.stringify(res),
                  type: 'error'
                });
              }
            });
          }
        })
        .catch(() => {
          console.log('取消');
        });
    },
    afterAllDel() {
      let cart = this.cartData;
      this.cartData = [];
      cart.forEach(e => {
        if (this.initSelected.indexOf(e[this.initRelKey]) < 0) {
          this.cartData.push(e);
        }
      });
      this.initSelected = [];
      this.init();
      this.$notify({
        title: '提示',
        message: '删除成功!',
        type: 'success'
      });
      window.scrollTo(0, 0);
    },
    deleteIndex(item, index) {
      // 单个删除
      // TODO 调接口删除购物车表内容
      this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          delCart(this, item.id, res => {
            if (res.code === 200) {
              let a = this.cartData[index];
              this.initSelected.forEach((e, i) => {
                if (e == a[this.initRelKey]) {
                  this.initSelected.splice(i, 1);
                }
              });
              this.cartData.splice(index, 1);
              if (this.current > 1) {
                if (this.cartData.length === 0) {
                  this.current--;
                  window.scrollTo(0, 0);
                  getCartList(this, () => {
                    this.init();
                  });
                }
              } else {
                this.getCartLiatCurrent1();
              }
              this.nodata = this.cartData.length > 0 ? false : true;
            } else {
              this.$notify({
                title: '提示',
                message: '删除失败：' + JSON.stringify(res),
                type: 'error'
              });
            }
          });
        })
        .catch(error => {
          console.log('取消');
        });
    },
    minusIndex(index) {
      // 数量减
      if (this.cartData[index].total > 1) {
        this.cartData[index].total -= 1;
      }
      this.init();
    },
    plusIndex(index) {
      // 数量加
      this.cartData[index].total++;
      this.init();
    },
    submit() {
      // 结算
      if (!this.totalAmount) {
        this.$notify({
          title: '提示',
          message: '请选择商品',
          type: 'warning'
        });
        return;
      }
      var data = {
        totalPrice: this.totalAmount,
        list: this.selectArr
      };
      //console.log(data);
      this.$store.dispatch('saveCartItemData', data);
      // window.localStorage.setItem("shopInfo", data);
      this.createdBool = false;
      this.$router.push({
        name: 'shopDetailOrder',
        query: {
          id: this.$route.query.id
        }
      });
    },
    //跳转商品详情
    goToShopDetail(item) {
      this.$router.push({
        path: '/shop/detail',
        query: {
          id: item.goods.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin checkbox {
  span {
    width: 14px;
    height: 14px;
    border: 1px solid #a8a8a8;
    display: inline-block;
    box-sizing: border-box;
    vertical-align: top;
    margin: 12px 20px;
    cursor: pointer;
    outline: 0;

    &.checked-active {
      background: #e70819;
      color: #fff;
      border: none;

      &::after {
        content: '\2714';
        display: block;
        text-align: center;
        font-size: 12px;
        color: #fff;
      }
    }
  }
}
h2 {
  font-size: 28px;
  color: #333;
  margin: 40px auto;
  max-width: 1200px;
  text-align: left;
  border-left: 4px solid #e70819;
  line-height: 28px;
  text-indent: 10px;
  font-weight: 600;
}
.jl-cart-list-wrapper {
  max-width: 1200px;
  padding-bottom: 120px;
  margin: 0 auto;

  .jl-cart-list-head {
    width: 100%;
    height: 40px;
    background: #f6f6f6;
    border: 1px solid #e0e0e0;
    color: #666;
    font-size: 14px;
    text-align: left;
    font-weight: 500;
    margin-bottom: 15px;

    .jl-cart-list-head-checkall {
      display: inline-block;
      vertical-align: top;

      @include checkbox;
    }
    ul {
      display: inline-block;
      vertical-align: top;
      line-height: 14px;
      margin: 13px 0;
      text-align: center;

      li {
        display: inline-block;
        margin-right: 20px;

        &:first-child {
          width: 80px;
          text-align: left;
          cursor: pointer;
        }
        &:nth-child(2) {
          width: 370px;
          text-align: left;
        }
        &:nth-child(3) {
          width: 196px;
        }
        &:nth-child(4) {
          width: 140px;
        }
        &:nth-child(5) {
          width: 190px;
        }
        &:last-child {
          text-align: left;
        }
      }
    }
  }
  .jl-cart-list-content {
    // min-height: 528px;

    .jl-cart-list-item {
      // height: 146px;
      border: 1px solid #e0e0e0;
      margin-bottom: 30px;
      text-align: left;
      font-weight: 500;

      .jl-cart-list-item-check {
        display: inline-block;
        vertical-align: top;

        @include checkbox;

        span {
          margin: 20px;
        }
      }
      ul {
        display: inline-block;
        vertical-align: top;
        margin: 20px 0;
        text-align: center;
        height: 106px;
        overflow: hidden;

        li {
          display: inline-block;
          margin-right: 20px;
          vertical-align: top;
          font-size: 14px;
          color: #333;

          &:first-child {
            width: 80px;
            // height: 106px;

            img {
              display: block;
              width: 100%;
              // height: 100%;
            }
          }
          &:nth-child(2) {
            width: 370px;
            text-align: left;
            font-size: 18px;

            p:first-child {
              color: #333;
              line-height: 24px;
              margin-bottom: 10px;
              max-height: 72px;
              overflow: hidden;
            }
            p:last-child {
              color: #666;
              font-size: 14px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          &:nth-child(3) {
            width: 196px;
            line-height: 28px;
          }
          &:nth-child(4) {
            width: 140px;

            button {
              display: inline-block;
              vertical-align: top;
              width: 28px;
              height: 28px;
              border: 1px solid #d6d6d6;
              color: #333;
              line-height: 28px;
              cursor: pointer;
              outline: none;
            }
            input {
              display: inline-block;
              width: 60px;
              height: 28px;
              margin: 0 10px;
              text-align: center;
              font-size: 18px;
              color: #e81727;
              border: 1px solid #a8a8a8;
              outline: 0;
            }
          }
          &:nth-child(5) {
            width: 190px;
            font-weight: bold;
          }
          &:last-child {
            text-align: left;
            cursor: pointer;

            &:hover {
              color: #e81727;
            }
          }
        }
      }
    }
  }
  .jl-cart-list-foot {
    height: 52px;
    background: #fff;
    margin: 0;

    .jl-cart-list-head-checkall > span {
      margin: 17px 20px;
    }
    .jl-cart-list-foot-left {
      display: inline-block;
      vertical-align: top;
      line-height: 14px;
      margin: 19px 0;

      span {
        margin-right: 40px;
        cursor: pointer;
      }
    }
    .jl-cart-list-foot-right {
      float: right;
      line-height: 52px;
      position: relative;

      div {
        color: #999;
        float: left;
        margin-right: 50px;

        &.jl-cart-list-foot-right-totalnum > span {
          margin: 0 5px;
          color: #e81727;
        }
        &.jl-cart-list-foot-right-summary {
          margin-right: 150px;

          p {
            line-height: 20px;
            text-align: right;
            margin-top: 3px;

            span {
              font-size: 18px;
              line-height: 18px;
              color: #e81727;
              font-weight: bold;
            }
          }
        }
      }
      button {
        display: block;
        width: 94px;
        height: 52px;
        position: absolute;
        background: #e81727;
        color: #fff;
        font-size: 16px;
        top: -1px;
        right: -1px;
        z-index: 100;
        outline: none;
        cursor: pointer;
      }
    }
  }
}

.jl-page-box {
  margin-top: 30px;
}
.js-cart-tips {
  position: relative;
  width: 100%;
  text-align: center;
  height: 300px;
  &::after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 100%;
  }
  i {
    font-size: 60px;
    color: #ccc;
  }
}
.js-cart-tips-box {
  display: inline-block;
  vertical-align: middle;
  .text-tips {
    font-size: 14px;
    color: #999;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}
.text-tips-btn {
  display: inline-block;
  width: 100px;
  height: 32px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #e70819;
  line-height: 32px;
  border-radius: 5px;
  cursor: pointer;
}
.cart-list-title {
  cursor: pointer;
}
</style>
